import { render, staticRenderFns } from "./EnableRemoteStatsCheckbox.vue?vue&type=template&id=32e30ef8&scoped=true"
import script from "./EnableRemoteStatsCheckbox.vue?vue&type=script&lang=js"
export * from "./EnableRemoteStatsCheckbox.vue?vue&type=script&lang=js"
import style0 from "./EnableRemoteStatsCheckbox.vue?vue&type=style&index=0&id=32e30ef8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32e30ef8",
  null
  
)

export default component.exports